exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notbox[data-v-3bc4f302]{width:100%;height:100vh;background:#fff;padding-top:2.666667rem;box-sizing:border-box}.notfount[data-v-3bc4f302]{width:6.906667rem;height:4rem;margin:auto}.notfount img[data-v-3bc4f302]{width:100%}.notfount p[data-v-3bc4f302]{font-size:.186667rem;font-family:PingFangSC;font-weight:400;color:#888;margin:.4rem 0 .2rem;text-align:center}", ""]);

// exports
